import { render, staticRenderFns } from "./DocumentPrintItemCard.vue?vue&type=template&id=ae8760ce&scoped=true"
import script from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintItemCard.vue?vue&type=style&index=0&id=ae8760ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8760ce",
  null
  
)

export default component.exports